import VueChartJs from 'vue-chartjs';

export default {
  extends: VueChartJs.Bar,
  mixins: [VueChartJs.mixins.reactiveProp],
  props: {
    labels: {
      type: Array,
      default: []
    },
    data: {
      type: Array,
      default: []
    }
  },
  mounted () {
  },
  watch: {
    data: {
      handler: function () {
        this.renderChart({
          labels: this.labels,
          datasets: [
            {
              label: '',
              data: this.data,
              backgroundColor: ['#FF4040', '#A60000', '#FF7400', '#A64B00', '#CD0074', '#E667AF', '#00CC00', '#008500', '#0F4DA8', '#052F6D', '#B1F100', '#D4F870', '#AF3BD4', '#E9FB00', '#F3FD72'
              ],
              borderColor: ['#FF4040', '#A60000', '#FF7400', '#A64B00', '#CD0074', '#E667AF', '#00CC00', '#008500', '#0F4DA8', '#052F6D', '#B1F100', '#D4F870', '#AF3BD4', '#E9FB00', '#F3FD72'
              ],
              pointBackgroundColor: 'rgba(139, 197, 213, 0.8)',
              pointBorderWidth: 1,
              pointRadius: 4,
              borderWidth: 3,
              pointHoverRadius: 20,
              showLine: true,

              lineTension: 0.1 // smooth line
              // steppedLine: true,

            }
          ]
        }, {
          chartArea: {
            backgroundColor: '#f5f5f5'
          },
          layout: {
            padding: {
              left: 20,
              right: 0,
              top: 0,
              bottom: 0
            }
          },
          scales: {
            xAxes: [{
              gridLines: {
                color: 'rgba(221, 221, 221, 0.8)',
                display: false,
                drawBorder: false
              },
              ticks: {
                padding: 5 // spacing with label

              },
              barPercentage: 1 // width of bar
            }],
            yAxes: [{
              gridLines: {
                color: 'rgba(221, 221, 221, 0.8)',
                display: true,
                drawBorder: false,
                zeroLineColor: 'rgba(221, 221, 221, 0.8)'
              },
              ticks: {
                padding: 5,
                min: 0,
                max: 5 // calculate max data value
              }
            }]
          },
          legend: {
            display: false // hide header
          },
          tooltips: {
            enabled: true
          },

          responsive: true,
          maintainAspectRatio: false
        })
      },
      deep: true
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/eventManagement/reports/event-bar-chart.js